import React from "react";
import { string, func } from "prop-types";

import { Icon } from "../../atoms/icon";
import "./member-directory-search.m.css";
import SearchIcon from "../../../../assets/icons/searchicon1";

export const MemberDirectorySearch = ({
  value,
  onChange,
  onClear,
  placeholder = "Search",
  ...props
}) => {
  const handleInputChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const handleClearClick = () => {
    if (onClear) {
      onClear();
    }
  };

  return (
    <div styleName="search-container" {...props}>
      <div styleName="search-wrapper">
        <div styleName="search-field">
          <div styleName="search-icon">
            <SearchIcon />
          </div>

          <input
            type="text"
            value={value}
            onChange={handleInputChange}
            placeholder={placeholder}
            styleName="search-input"
          />

          <div styleName="icons-container">
            {(
              <button
                type="button"
                onClick={handleClearClick}
                styleName="clear-button"
              >
                <Icon name="close" size="xsmall" color="secondary" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

MemberDirectorySearch.propTypes = {
  value: string,
  onChange: func,
  onClear: func,
  placeholder: string
};